import * as React from 'react';
import Container from '@lendi-ui/container';
import ArticleCard from '../ArticleCard';
import { ArticleScroller, ArticleScrollWrapper } from '../ArticleScroller';
import { InnerWrapper, OuterWrapper, Title } from './index.style';
import { Article } from '../../utils/schema';

const RelatedArticles = ({ articles }: { articles: Article[] }) => (
  <OuterWrapper>
    <Container>
      <InnerWrapper>
        <Title>Related articles</Title>
        <ArticleScrollWrapper>
          <ArticleScroller>
            {articles.map((article) => (
              <ArticleCard article={article} showSummary={false} key={article.id} />
            ))}
          </ArticleScroller>
        </ArticleScrollWrapper>
      </InnerWrapper>
    </Container>
  </OuterWrapper>
);

export default RelatedArticles;
